import React from "react";
import LookupFormPage from "./LookupFormPage";

function PillarFormPage() {
  return (
    <LookupFormPage
      title="Pillar"
      endpoint="/pillars"
      listPath="/pillars"
      fields={[
        { name: "name", label: "Name" },
        { name: "description", label: "Description", type: "textarea", required: false }
      ]}
    />
  );
}

export default PillarFormPage;
